import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientApps } from '@shared/models';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';
import { LenderHubDataService } from '@shared/services/lenderhub-data.service';

export interface DisclaimerResponse {
  disclaimerRead: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DisclaimerService {
  private readonly lenderHubDataService = inject(LenderHubDataService);
  private readonly clubHubDataService = inject(ClubHubDataService);

  public setDisclaimerAsRead(client: ClientApps): Observable<void> {
    switch (client) {
      case ClientApps.ClubHub:
        return this.clubHubDataService.post('Broker/UserReadLatestDisclaimer', null);
      case ClientApps.LenderHub:
        return this.lenderHubDataService.post('LenderDisclaimer/UserReadLatestDisclaimer', null);
      default:
        throw new Error('Unrecognised client error');
    }
  }

  public hasUserDisclaimerBeenRead(client: ClientApps): Observable<DisclaimerResponse> {
    switch (client) {
      case ClientApps.ClubHub:
        return this.clubHubDataService.get<DisclaimerResponse>('Broker/UserReadLatestDisclaimer');
      case ClientApps.LenderHub:
        return this.lenderHubDataService.get<DisclaimerResponse>('LenderDisclaimer/UserReadLatestDisclaimer');
      default:
        throw new Error('Unrecognised client error');
    }
  }
}
